import { render } from "./TrancarMatricula.vue?vue&type=template&id=18b3f2c4&scoped=true"
import script from "./TrancarMatricula.vue?vue&type=script&lang=js"
export * from "./TrancarMatricula.vue?vue&type=script&lang=js"

import "./TrancarMatricula.vue?vue&type=style&index=0&id=18b3f2c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b3f2c4"]])

export default __exports__